import { render, staticRenderFns } from "./ChatbotLink.vue?vue&type=template&id=44be9345&scoped=true"
import script from "./ChatbotLink.vue?vue&type=script&lang=js"
export * from "./ChatbotLink.vue?vue&type=script&lang=js"
import "./ChatbotLink.vue?vue&type=style&index=0&id=44be9345&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44be9345",
  null
  
)

export default component.exports